import React from 'react';
import {
  extend,
  arrayOf as arrayType,
  bool as boolType,
  number as numberType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { arrayOf as propTypeArrayOf, shape as shapeProp,
  bool as boolProp, string as stringProp } from 'prop-types';
import { BundleInformationMetadata } from '@thd-olt-component-react/metadata';

const BundleMetadata = ({
  product, products,
  itemId,
  pageDescription,
  pageNumber,
  pageTitle,
  ppq,
  questionsCanonical,
  reviewsCanonical,
  hideIfHDPPSku,
  variables
}) => {
  if (!product || !products?.length) {
    return null;
  }
  return (
    <>
      <BundleInformationMetadata
        itemId={itemId}
        bundleProduct={product}
        bundleProducts={products}
        pageDescription={pageDescription}
        pageNumber={pageNumber}
        pageTitle={pageTitle}
        ppq={ppq}
        questionsCanonical={questionsCanonical}
        reviewsCanonical={reviewsCanonical}
        hideIfHDPPSku={hideIfHDPPSku}
        requestVariables={variables}
        skipProductsRequest
      />
    </>
  );
};

BundleMetadata.propTypes = {
  product: shapeProp({}).isRequired,
  products: propTypeArrayOf(shapeProp()).isRequired,
  itemId: stringProp.isRequired,
  reviewsCanonical: boolProp,
  pageNumber: stringProp,
  pageTitle: stringProp,
  pageDescription: stringProp,
  questionsCanonical: boolProp,
  ppq: boolProp,
  hideIfHDPPSku: boolProp,
  variables: shapeProp({}).isRequired
};

BundleMetadata.defaultProps = {
  reviewsCanonical: false,
  pageNumber: null,
  pageTitle: null,
  pageDescription: null,
  questionsCanonical: false,
  ppq: false,
  hideIfHDPPSku: false
};

BundleMetadata.displayName = 'BundleMetadata';

BundleMetadata.dataModel = extend({
  products: params({ itemIds: arrayType(stringType().isRequired()).isRequired() }).arrayOf({
    itemId: stringType(),
    identifiers: shapeType({
      brandName: stringType(),
      productLabel: stringType(),
      productType: stringType()
    }),
    media: shapeType({
      video: arrayType({
        shortDescription: stringType(),
        thumbnail: stringType(),
        url: stringType(),
        videoStill: stringType(),
        uploadDate: stringType(),
        dateModified: stringType()
      })
    })
  })
},
{
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    availabilityType: shapeType({
      discontinued: boolType(),
      status: boolType()
    }),
    details: shapeType({
      description: stringType()
    }),
    identifiers: shapeType({
      brandName: stringType(),
      canonicalUrl: stringType(),
      itemId: stringType(),
      modelNumber: stringType(),
      productLabel: stringType(),
      storeSkuNumber: stringType(),
      upcGtin13: stringType(),
      skuClassification: stringType(),
      omsThdSku: stringType()
    }),
    info: shapeType({
      returnable: stringType()
    }),
    media: shapeType({
      image: shapeType({
        url: stringType()
      }).client(),
      images: arrayType(shapeType({
        url: stringType(),
        type: stringType(),
        subType: stringType(),
        sizes: arrayType(stringType())
      })),
      video: arrayType(shapeType({
        shortDescription: stringType(),
        thumbnail: stringType(),
        url: stringType(),
        videoStill: stringType(),
        uploadDate: stringType(),
        dateModified: stringType()
      }))
    }),
    pricing: params({ storeId: stringType() }).shape({
      promotion: shapeType({
        dates: shapeType({
          end: stringType()
        })
      }),
      value: numberType({ float: true }),
      original: numberType({ float: true })
    }),
    reviews: shapeType({
      ratingsReviews: shapeType({
        averageRating: stringType(),
        totalReviews: stringType()
      })
    }),
    seo: shapeType({
      seoKeywords: stringType(),
      seoDescription: stringType()
    }),
    specificationGroup: arrayType(shapeType({
      specifications: arrayType(shapeType({
        specName: stringType(),
        specValue: stringType()
      })),
      specTitle: stringType()
    })),
    taxonomy: shapeType({
      breadCrumbs: arrayType(shapeType({
        label: stringType(),
        url: stringType()
      }))
    })
  })
},
BundleInformationMetadata);

export { BundleMetadata };